export class TreelistData {
  columnsData: Map<string, boolean>;
  rowKey: string;

  constructor(init?: Partial<TreelistData>) {
    Object.assign(this, init);
  }
}
